import React, { PureComponent } from "react";
import { connect } from "react-redux";

import { setCurrentNavPage, setAttachmentFileLink } from "Actions";
import {
  fetchDashboard,
  fetchComments,
  fetchIndicatorsExplanation,
  fetchSupportedIndicatorVars,
  fetchPresentation
} from "Thunks";
import styles from "./Presentation.local.scss";
import Presentation from "./Presentation";
import { getTemporaryAnnexeFileLink } from "Utils";
import { selectRouting } from "Selectors";
import browserHistory from "history/createBrowserHistory";

class PresentationPage extends PureComponent {
  organizationUen;

  constructor(props) {
    super(props);
    const index = Number(window.location.href.split("/")[5] - 1);

    this.state = {
      hideIframe: true,
      loadingIframe: true,
      isNotFound: false,
      thanks: false,
      question: false,
      comments: [],
      startIndex: 0,
      index: index ? index : 0
    };
  }

  componentDidMount() {
    const { dispatch, currentNavPage, organizationUen } = this.props;

    // GETTING YEAR OF DASHBOARD FROM URL
    let defaultYear = browserHistory().location.search;
    let year =
      defaultYear && defaultYear.includes("year")
        ? defaultYear.replace("?year=", "").slice(0, 4)
        : null;
    // ****

    this.organizationUen = organizationUen;
    if (!organizationUen) {
      let { uen } = this.props.match.params;
      this.organizationUen = uen;
    }

    if (!this.organizationUen) {
      return false;
    }

    if (currentNavPage !== "PRESENTATION_PAGE") {
      dispatch(setCurrentNavPage("DIAPORAMA_PAGE"));
    }
    let target = this.organizationUen;
    dispatch(fetchDashboard(year, this.organizationUen, target)).then(res => {
      let ownerUen = res.value.data.data.organization.ownerUen;
      if (ownerUen) {
        dispatch(fetchSupportedIndicatorVars(ownerUen));
      }
    });
    dispatch(fetchPresentation(this.organizationUen, year));
    dispatch(fetchComments(this.organizationUen, year));
    dispatch(fetchIndicatorsExplanation(this.organizationUen));
  }

  displayAnnexePDF = annexeCategory => {
    const { annexeAttachments, token } = this.props;
    this.setState({
      hideIframe: false,
      loadingIframe: true,
      isNotFound: false
    });

    let annexe = annexeAttachments.filter(
      ({ category }) => category.id === annexeCategory
    );

    if (annexe[0]) {
      this.props.dispatch(
        setAttachmentFileLink(
          getTemporaryAnnexeFileLink(annexe[0].id, annexe[0].filePath, token)
        )
      );
      setTimeout(() => {
        this.setState({ loadingIframe: false });
      }, 2000);
    } else {
      setTimeout(() => {
        this.setState({ loadingIframe: false, isNotFound: true });
      }, 2000);
    }
  };

  closeAnnexePDF = () => {
    this.setState({ hideIframe: true });

    this.props.dispatch(setAttachmentFileLink(""));
  };

  componentWillUnmount(): void {
    this.closeAnnexePDF();
  }

  render() {
    const {
      dashboardData,
      organization,
      fetching,
      fetched,
      dispatch,
      attachmentFileLink,
      presentation,
      currentNavPage,
      routing
    } = this.props;

    let { hideIframe, loadingIframe, isNotFound } = this.state;

    if (presentation && presentation.id) {
      if (
        dashboardData.slides &&
        presentation.extraSlides.enabled &&
        !dashboardData.slides.find(slide => slide.layout.type === "EXTRA_SLIDE")
      ) {
        presentation.extraSlides.slides.forEach(item => {
          dashboardData.slides.splice(item.page - 1, 0, {
            id: 0,
            labels: { fr: item.title, en: "", nl: "" },
            layout: {
              label: item.title,
              type: "EXTRA_SLIDE",
              config: {
                background: "url(/img/back_blue.png)",
                componentsBackground: "#FFFFFF"
              },
              components: [item]
            }
          });
        });
        // dashboardData.slides.push({
        //   id: 0,
        //   label: "Conclusion",
        //   layout: {
        //     label: "Conclusion",
        //     type: "CONCLUSION_SLIDE",
        //     config: {
        //       background: "url(/img/back_blue.png)",
        //       componentsBackground: "#FFFFFF"
        //     },
        //     data: {}
        //   }
        // });
      }

      if (dashboardData.slides && presentation.hiddenSlides.length > 0) {
        let slides = dashboardData.slides.filter(
          slide => !presentation.hiddenSlides.find(item => item === slide.id)
        );
        dashboardData.slides = slides;
      }

      if (
        dashboardData.slides &&
        presentation.thankingSlide &&
        !dashboardData.slides.find(
          slide => slide.layout.type === "THANKING_SLIDE"
        )
      ) {
        dashboardData.slides.push({
          id: 0,
          layout: {
            labels: { fr: "Remerciement", en: "", nl: "" },
            type: "THANKING_SLIDE",
            config: {
              background: "url(/img/back_blue.png)",
              componentsBackground: "#FFFFFF"
            },
            data: {}
          }
        });
      }

      if (
        dashboardData.slides &&
        presentation.questionsSlide &&
        !dashboardData.slides.find(
          slide => slide.layout.type === "QUESTIONS_SLIDE"
        )
      ) {
        dashboardData.slides.push({
          id: 0,
          layout: {
            labels: { fr: "Questions", en: "", nl: "" },
            type: "QUESTIONS_SLIDE",
            config: {
              background: "url(/img/back_blue.png)",
              componentsBackground: "#FFFFFF"
            },
            data: {}
          }
        });
      }
    }

    if (
      dashboardData &&
      dashboardData.slides &&
      Array.isArray(dashboardData.slides) &&
      dashboardData.slides[0] &&
      dashboardData.slides[0].layout.type !== "LAYOUT_0"
    ) {
      dashboardData.slides.unshift({
        id: 0,
        layout: {
          labels: "layout 0",
          type: "LAYOUT_0",
          config: { background: "url(/img/presentation-background.png)" },
          data: { organization: organization, label: dashboardData.label }
        }
      });
    }

    return (
      <div className={styles.diaporama_frame}>
        {fetching && (
          <div className={styles.ripple_loading}>
            <img src={"/img/Ripple-1s-150px.svg"} alt="" />
          </div>
        )}
        {fetched &&
          dashboardData && (
            <Presentation
              data={dashboardData}
              organization={organization}
              dispatch={dispatch}
              handleDisplayAnnexePDF={this.displayAnnexePDF}
              hideIframe={hideIframe}
              srcIframe={attachmentFileLink}
              loadingIframe={loadingIframe}
              onCloseIframe={this.closeAnnexePDF}
              isNotFound={isNotFound}
              currentNavPage={currentNavPage}
              location={routing.location}
            />
          )}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching:
    state.indicators.suggestions.fetching ||
    state.dashboard.fetching ||
    state.presentation.fetching ||
    state.preparePresentation.fetching,
  fetched:
    state.indicators.suggestions.fetched &&
    state.dashboard.fetched &&
    state.presentation.fetched &&
    state.preparePresentation.fetched,
  dashboardData: state.dashboard.data,
  organization: state.dashboard.organization,
  attachmentFileLink: state.dashboard.attachmentFileLink,
  currentOrganization: state.auth.currentOrganization,
  annexeAttachments: state.dashboard.data.annexeAttachments,
  token: state.auth.token,
  presentation: state.presentation.data,
  currentNavPage: state.params.currentNavPage,
  routing: selectRouting(state)
});

export default connect(mapStateToProps)(PresentationPage);



// WEBPACK FOOTER //
// ./src/components/Presentation/PresentationPage.js